import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Typography,
  Box,
  Alert,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ManualMergeDialog = ({ open, onClose, mergeResult }) => {
  const {
    success,
    message,
    mergedDonor,
    donationsMerged,
    sourceDonorId,
    targetDonorId,
  } = mergeResult || {};

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <div
        className="modal-header"
        style={{
          background: success ? "#4caf50" : "#f44336",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          borderBottom: "1px solid #ddd",
        }}
      >
        <DialogTitle style={{ color: "white", padding: 0 }}>
          <CheckCircleIcon sx={{ mr: 1 }} />
          {success ? "Merge Successful" : "Merge Failed"}
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon sx={{ color: "white" }} />
        </IconButton>
      </div>

      <DialogContent sx={{ p: 3 }}>
        {success ? (
          <Box>
            <Alert severity="success" sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Donors merged successfully!
              </Typography>
              <Typography variant="body2">{message}</Typography>
            </Alert>

            {mergedDonor && (
              <Box mb={3}>
                <Typography variant="h6" gutterBottom>
                  Merged Donor Details:
                </Typography>
                <Box p={2} bgcolor="#e8f5e8" borderRadius={1}>
                  <Typography variant="body1">
                    <strong>Donor ID:</strong> {mergedDonor.donorId}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Name:</strong> {mergedDonor.firstName}{" "}
                    {mergedDonor.lastName}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Mobile:</strong> {mergedDonor.mobile1 || "N/A"}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Email:</strong> {mergedDonor.mailId || "N/A"}
                  </Typography>
                </Box>
              </Box>
            )}

            <Divider sx={{ my: 2 }} />

            <Box>
              <Typography variant="h6" gutterBottom>
                Merge Summary:
              </Typography>
              <Box p={2} bgcolor="#f5f5f5" borderRadius={1}>
                <Typography variant="body1" gutterBottom>
                  <strong>Source Donor ID:</strong> {sourceDonorId} (Deleted)
                </Typography>
                <Typography variant="body1" gutterBottom>
                  <strong>Target Donor ID:</strong> {targetDonorId} (Updated)
                </Typography>
                <Typography variant="body1" color="primary">
                  <strong>Donations Transferred:</strong> {donationsMerged || 0}{" "}
                  donations
                </Typography>
              </Box>
            </Box>

            {donationsMerged > 0 && (
              <Alert severity="info" sx={{ mt: 2 }}>
                <Typography variant="body2">
                  All {donationsMerged} donations from the source donor have
                  been successfully transferred to the target donor. The
                  donation history is preserved.
                </Typography>
              </Alert>
            )}
          </Box>
        ) : (
          <Box>
            <Alert severity="error" sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Merge Failed
              </Typography>
              <Typography variant="body2">
                {message ||
                  "An error occurred while merging the donors. Please try again."}
              </Typography>
            </Alert>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, borderTop: "1px solid #ddd" }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          size="large"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManualMergeDialog;
